import { useCallback } from "react";

export const useUpdateReservation = (
  apiSingleReservationUrl: string,
  updateReservation: (data: any) => void
) => {
  const updateReservationDetails = useCallback(async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) throw new Error("JWT Token not found");

      const updatedReservationResponse = await fetch(apiSingleReservationUrl, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const updatedReservationData = await updatedReservationResponse.json();
      updateReservation(updatedReservationData);
    } catch (error) {
      console.error("Error fetching updated reservation details:", error);
    }
  }, [apiSingleReservationUrl, updateReservation]);

  return { updateReservationDetails };
};
